import { useAuthentication } from '@ecosystem/newron-client-lib';
import { feedback } from '@ecosystem/newron-design-system';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isValidToken } from '@utils/TokenUtils';
import { getCorsOriginHeader } from '@utils/AllowedWhitelistDomainsUtils';
import { getImpersonationHeader } from '@utils/impersonateUtils/ImpersonationUtil';

const Authentication = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, getAccessToken, logout } = useAuthentication();
  const [token, setToken] = useState<string>('');
  useEffect(() => {
    const initiateAuthHandling = async () => {
      try {
        if (isAuthenticated) {
          const accessToken = (await getAccessToken()) ?? '';
          setToken(accessToken);
        }
      } catch (err: any) {
        console.error(err);
      }
    };
    initiateAuthHandling();
  }, [isAuthenticated]);

  if (token === '') {
    return <></>;
  }

  axios.interceptors.request.use(async (config: any) => {
    if (!isValidToken(token)) {
      logout();
    }
    const originHeader = config.url && getCorsOriginHeader(config.url);
    if (!originHeader) {
      logout();
    }
    const impersonationHeader = await getImpersonationHeader();
    if (!impersonationHeader) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
        ...impersonationHeader,
        params: { ...config.params },
      };
    }
    // Ensure params are preserved
    config.params = {
      ...config.params,
    };
    return config;
  });

  return isAuthenticated ? <>{children}</> : <feedback.DotsLoader />;
};

export default Authentication;
